import * as yup from "yup";

export const comentarioSchema = yup
    .object({
        comentario: yup
            .string()
            .min(3, "El texto debe contener más de 3 caracteres")
            .required("El nombre de usuario es obligatorio"),
    })
    .required();